import axios from 'axios';

export interface VotacaoCandidato {
  candidato_id: string;
  nome: string;
  votos: number;
  percentual: number;
}

export interface VotacaoZona {
  zona: string;
  total_votos: number;
  resultados: VotacaoCandidato[];
}

export interface VotacaoDesempenho {
  ciclo: number;
  total_geral: number;
  desempenho_geral: VotacaoCandidato[];
  detalhe_zonas: VotacaoZona[];
}

const API_URL = import.meta.env.VITE_API_URL || '/api';

export const votacaoApi = {
  getDesempenho: async (ciclo: number, token: string) => {
    const res = await axios.get<VotacaoDesempenho>(`${API_URL}/eleg/votacao/desempenho`, {
      params: { ciclo },
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};
